var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_2",
    d: "M14.1514 1.77046C15.1435 0.778336 16.738 0.778336 17.7301 1.77046L18.1908 2.23109C19.1829 3.22322 19.1829 4.81771 18.1908 5.80983L11.175 12.8256C10.8915 13.109 10.5018 13.3571 10.0766 13.4634L6.53327 14.4909C6.24981 14.5618 5.93091 14.4909 5.71831 14.2429C5.47028 14.0303 5.39941 13.7114 5.47028 13.4279L6.49784 9.88463C6.60414 9.45944 6.85217 9.06967 7.13563 8.78621L14.1514 1.77046ZM16.5254 2.97519C16.2065 2.65629 15.675 2.65629 15.3561 2.97519L14.2931 4.00274L15.9585 5.6681L16.986 4.60511C17.3049 4.28621 17.3049 3.75471 16.986 3.43582L16.5254 2.97519ZM8.12776 10.3453L7.5254 12.4358L9.61595 11.8335C9.75768 11.798 9.86398 11.7272 9.97028 11.6209L14.7537 6.83739L13.1238 5.20747L8.34036 9.99093C8.23406 10.0972 8.16319 10.2035 8.12776 10.3453ZM8.02146 3.15235C8.48209 3.15235 8.87185 3.54211 8.87185 4.00274C8.87185 4.49881 8.48209 4.85314 8.02146 4.85314H4.05296C3.238 4.85314 2.63563 5.49093 2.63563 6.27046V15.9083C2.63563 16.7232 3.238 17.3256 4.05296 17.3256H13.6908C14.4703 17.3256 15.1081 16.7232 15.1081 15.9083V11.9398C15.1081 11.4791 15.4624 11.0894 15.9585 11.0894C16.4191 11.0894 16.8089 11.4791 16.8089 11.9398V15.9083C16.8089 17.6445 15.3915 19.0264 13.6908 19.0264H4.05296C2.31674 19.0264 0.934847 17.6445 0.934847 15.9083V6.27046C0.934847 4.56967 2.31674 3.15235 4.05296 3.15235H8.02146Z",
    fill: "#ACB3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.237187f16d85ababae7e6eecf10e4d9b.svg";
export { ForwardRef as ReactComponent };